var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 1.74997C10.07 1.59676 10.2518 1.47523 10.452 1.39232C10.6522 1.3094 10.8667 1.26672 11.0834 1.26672C11.3001 1.26672 11.5146 1.3094 11.7148 1.39232C11.915 1.47523 12.0969 1.59676 12.2501 1.74997C12.4033 1.90318 12.5248 2.08507 12.6077 2.28524C12.6907 2.48542 12.7333 2.69997 12.7333 2.91664C12.7333 3.13331 12.6907 3.34786 12.6077 3.54804C12.5248 3.74821 12.4033 3.9301 12.2501 4.08331L4.37508 11.9583L1.16675 12.8333L2.04175 9.62497L9.91675 1.74997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePen);
export default __webpack_public_path__ + "static/media/whitePen.797977d14c7a4729429b602819baac6b.svg";
export { ForwardRef as ReactComponent };